module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ../~/redux-optimist/index.js
// module id = 405
// module chunks = 0